import { createContext, useContext, useState, useEffect } from 'react';


const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || 'preview-token');
  const [user, setUser] = useState(() => {
    const rawUser = localStorage.getItem('preview_user') || localStorage.getItem('demo_user');
    return rawUser ? JSON.parse(rawUser) : null;
  });

  useEffect(() => {
    if (!token || user) return;
    const rawUser = localStorage.getItem('preview_user') || localStorage.getItem('demo_user');
    if (rawUser) setUser(JSON.parse(rawUser));
  }, [token, user]);

  const login = (payload) => {
    if (typeof payload === 'string') {
      localStorage.setItem('token', payload);
      setToken(payload);
      return;
    }

    const sessionToken = payload?.token || 'preview-token';
    const sessionUser = payload?.user || null;

    localStorage.setItem('token', sessionToken);
    if (sessionUser) {
      localStorage.setItem('preview_user', JSON.stringify(sessionUser));
      setUser(sessionUser);
    }
    setToken(sessionToken);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('preview_user');
    localStorage.removeItem('demo_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
